export default {"src":"/_next/static/media/youtube.e464ccaa.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};